{
  "defaultCurrencyConfig": {
    "symbol": " $",
    "positionLeft": false
  },
  "wrapper": {
    "header": {
      "book-now": "Réservez maintenant.",
      "pay": "Payez au fil du temps.",
      "powered-by": "Optimisé par "
    },
    "footer": {
      "uplift": {
        "email": "support@uplift.ca"
      },
      "flexpay": {
        "email": "soutien@upgrade.com"
      },
      "telephone": {
        "link": "+18442575400",
        "text": "(844) 257-5400",
        "full": "+1 (844) 257-5400"
      }
    },
    "agent-updated": {
      "message": "Votre agent a mis à jour les détails de votre voyage. Avant de continuer, veuillez vous assurer que l'itinéraire mis à jour est exact.",
      "dismiss": "Rejeter"
    }
  },
  "document-view": {
    "buttons": {
      "close": {
        "label": "Fermer"
      },
      "print": {
        "label": "Imprimer"
      }
    }
  },
  "time": {
    "months": {
      "1": "janv",
      "2": "févr",
      "3": "mars",
      "4": "avril",
      "5": "mai",
      "6": "juin",
      "7": "juil",
      "8": "août",
      "9": "sept",
      "10": "oct",
      "11": "nov",
      "12": "déc"
    }
  },
  "regions": {
    "AB": "Alberta",
    "BC": "Colombie-Britannique",
    "MB": "Manitoba",
    "NB": "Nouveau-Brunswick",
    "NL": "Terre-Neuve-et-Labrador",
    "NT": "Territoires du Nord-Ouest",
    "NS": "Nouvelle-Écosse",
    "NU": "Nunavut",
    "ON": "Ontario",
    "PE": "Île-du-Prince-Édouard",
    "QC": "Québec",
    "SK": "Saskatchewan",
    "YT": "Territoire du Yukon"
  },
  "processing": "En cours...",
  "mcodes": {
    "-100": "",
    "-1": "Oups! Il s’est produit quelque chose d'inattendu.",
    "0": "Demande non valide",
    "1": "Désolé, cet itinéraire n'est pas admissible au Plan de paiement par mensualités.",
    "2": "Désolé, cet itinéraire n'est pas admissible au Plan de paiement par mensualités.",
    "3": "Une erreur s'est produite dans le traitement de votre demande. Veuillez réessayer dans quelques minutes. Si le problème persiste, veuillez contacter le service de Soutien d’Uplift.",
    "4": "<div><span>Il y a eu trop de tentatives de vérification de ce numéro de cellulaire.</span><br/><span>Veuillez utiliser un autre numéro ou réessayer après 24 heures.</span></div>",
    "5": "Le code de vérification est incorrect.",
    "6": "Le numéro d’assurance sociale ne correspond pas.",
    "7": "La vérification de votre identité pose des difficultés, nous ne pouvons donc pas traiter votre demande de prêt.",
    "8": "Désolé, le délai d’attente de la requête a expiré. Veuillez réessayer.",
    "9": "Ce numéro de mobile est déjà associé à un compte aux USA / Anglais",
    "10": "Région non prise en charge",
    "11": "Code postal non pris en charge",
    "12": "Les adresses de boîte postale ne sont pas prises en charge. Veuillez fournir une adresse municipale complète pour continuer.",
    "13": "Pays non pris en charge",
    "14": "Votre session a pris fin ou votre demande de prêt préalable a expiré. Veuillez demander à votre agent de voyage d’envoyer une nouvelle demande de prêt pour paiement par mensualités. Votre pointage de crédit ne sera pas affecté si vous faites une nouvelle demande de prêt.",
    "15": "Le pays associé à votre demande de prêt a changé. Veuillez demander à votre agent de voyage d'envoyer une nouvelle demande de prêt pour paiement par mensualités. Votre pointage de crédit ne sera pas affecté si vous effectuez une nouvelle demande de prêt.",
    "16": "La langue associée à votre demande de prêt a changé. Veuillez demander à votre agent de voyage d'envoyer une nouvelle demande de prêt pour paiement par mensualités. Votre pointage de crédit ne sera pas affecté si vous effectuez une nouvelle demande de prêt.",
    "17": "La devise associée à votre demande de prêt a changé. Veuillez demander à votre agent de voyage d'envoyer une nouvelle demande de prêt pour paiement par mensualités. Votre pointage de crédit ne sera pas affecté si vous effectuez une nouvelle demande de prêt.",
    "18": "Transaction refusée. Veuillez utiliser un autre mode de paiement.",
    "19": "Vous avez dépassé le délai accordé à la demande de crédit. Veuillez effectuer une nouvelle demande pour pouvoir poursuivre. Si vous faites une nouvelle demande, votre cote de crédit n'en sera pas affectée.",
    "20": "<span>Il semble que la personne qui ait fait la demande de prêt ne voyage plus. Malheureusement, Uplift ne peut consentir de prêt qu'à <strong>une personne inscrite sur votre itinéraire</strong>.</span>",
    "50": "UpLift connaît actuellement des difficultés techniques. Veuillez réessayer.",
    "51": "Transaction refusée. Veuillez utiliser un autre mode de paiement.",
    "52": "Désolé, UpLift n'a pu accéder au document que vous avez demandé. Veuillez réessayer.",
    "60": "Veuillez sélectionner pour continuer.",
    "bls-0": "Erreur interne. Veuillez vérifier si toutes les données ont bien été saisies ou essayez une autre carte.",
    "bls-2": "Ce mode de paiement n'est pas accepté. Veuillez vérifier si toutes les données ont bien été saisies ou essayez une autre carte.",
    "bls-3": "Cartes American Express non acceptées. Veuillez vérifier si toutes les données ont bien été saisies ou essayez une autre carte.",
    "bls-4": "Carte non acceptée. Veuillez vérifier si toutes les données ont bien été saisies ou essayez une autre carte.",
    "bls-5": "Cartes Visa non acceptées. Veuillez vérifier si toutes les données ont bien été saisies ou essayez une autre carte.",
    "bls-6": "Ce mode de paiement n'est pas accepté. Veuillez vérifier si toutes les données ont bien été saisies ou essayez une autre carte."
  },
  "documents": {
    "cpa": "l'Autorisation au profil de crédit",
    "tos": "Conditions d'utilisation",
    "pp": "Politique de confidentialité",
    "esign": "Consentement à la signature électronique",
    "icc": "Augmentation du coût du crédit / Avis de décision défavorable",
    "loanAgreement": "Loan Agreement",
    "paymentAgreement": "Payment Terms Agreement",
    "til": "Contrat de prêt",
    "bapn": "(FR) Borrower Agreement & Promissory Note",
    "dcd": "Entente sur les conditions de paiement",
    "ach": "Entente de débits préautorisés",
    "drd": "Divulgation du taux d'endettement"
  },
  "failedToLoad": "<span>Échec du chargement de {{documentName}}.</span>",
  "retry": "Réessayez?",
  "from": "de ",
  "cobrandedLoading": "<UpliftLogo /> devient <FlexpayLogo />",
  "flexpay": {
    "fullAddress": "1080 Beaver Hall Hl Suite 200<br>Montreal, QC H2Z 1S8",
    "fullCompanyName": "Uplift Canada Services ULC",
    "payableCompanyName": "Uplift Canada Services ULC",
    "payableCompanyAddressName": "Flex Pay, Uplift Canada Services ULC",
    "productMessage": "Flex Pay, anciennement connu sous le nom de Uplift,",
    "website": "upgrade.com/pay"
  },
  "uplift": {
    "fullAddress": "410 Adelaide Street West<br>Suite 220<br>Toronto, ON M5V 1S8",
    "fullCompanyName": "Uplift Canada Services ULC",
    "payableCompanyName": "Uplift Canada",
    "payableCompanyAddressName": "Uplift Canada Services ULC",
    "website": "pay.uplift.com"
  }
}
